import { badgeClasses as muiBadgeClasses, getBadgeUtilityClass } from '@mui/material';
import { BadgeSize } from './types';

export const badgeClasses = {
  ...muiBadgeClasses,
  xs: getBadgeUtilityClass('xs'),
  sm: getBadgeUtilityClass('sm'),
  md: getBadgeUtilityClass('md'),
  lg: getBadgeUtilityClass('lg'),
  xl: getBadgeUtilityClass('xl'),
};

const badgeSizes: Record<
BadgeSize, number
> = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 40,
  xl: 56,
};

export const getBadgeSizeCss = (size: BadgeSize, ...additionalClasses: string[]) => {
  const sizeValue = badgeSizes[size];

  let selector = `&.${badgeClasses[size]}`;
  if (additionalClasses && additionalClasses.length) {
    selector += `, ${additionalClasses.join(', ')}`;
  }

  return {
    [selector]: {
      width: sizeValue,
      height: sizeValue,
    },
  };
};
